import {
  FaCalendarCheck,
  FaGears,
  FaHouse,
  FaListCheck,
} from "react-icons/fa6";

const MenuKabagKeamanan = [
  {
    label: "Home",
    to: "",
    icon: <FaHouse />,
  },
  {
    label: "Operasional Mobil",
    type: "menu-title",
  },
  {
    label: "Jadwal Mobil",
    to: "transaksi/jadwal-mobil",
    icon: <FaCalendarCheck />,
  },
  {
    label: "Cek Mobil",
    to: "transaksi/cek-keluar-masuk",
    icon: <FaListCheck />,
  },
  {
    label: "Problem Mobil",
    to: "problem/problem-kendaraan",
    icon: <FaGears />,
  },
  {
    label: "Operasional Trado",
    type: "menu-title",
  },
  {
    label: "Jadwal Trado",
    to: "transaksi/jadwal-trado",
    icon: <FaCalendarCheck />,
  },
  {
    label: "Cek Trado",
    to: "transaksi/cek-keluar-masuk-trado",
    icon: <FaListCheck />,
  },
  {
    label: "Problem Trado",
    to: "problem/problem-kendaraan-trado",
    icon: <FaGears />,
  },
  {
    label: "Lain-Lain",
    type: "menu-title",
  },
];

export default MenuKabagKeamanan;
